export default __webpack_public_path__ + "1be95633cb512b515bb360632786704f.svg";